import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import withLoading from './components/withLoading';
import ProfilePage from './pages/Profile/profile';

// Import all components with loading
const Home = withLoading(require('./pages/home/home').default);
const About = withLoading(require('./pages/about/about').default);
const Contact = withLoading(require('./pages/Contact/contact').default);
const BlogList = withLoading(require('./pages/Blogs/blogs').BlogList);
const BlogPost = withLoading(require('./pages/Blogs/blogs').BlogPost);
const Gallery = withLoading(require('./pages/Gallery/gallery').default);
const Membership = withLoading(require('./pages/Membership/membership').default);
const Form = withLoading(require('./pages/Membership/form').default);
const Raise = withLoading(require('./pages/service/raiseticket').default);
const Team = withLoading(require('./pages/about/team').default);
const Events = withLoading(require('./pages/events/events').default);
const Register = withLoading(require('./components/register').default);
const Login = withLoading(require('./components/login').default);
const Conform = withLoading(require('./pages/Membership/conformation').default);
const Privacy = withLoading(require("./pages/privacy/privacy").default);
const Terms = withLoading(require("./pages/terms/terms").default);
const Tamil = withLoading(require("./pages/tamilschool/tamilschool").default);
const ResetPassword = withLoading(require('./pages/ForgetPassword/resetpassword').default);
const SuccessPage = withLoading(require('./components/success').default);
const FailurePage = withLoading(require('./components/failure').default);
const ProductDisplay = withLoading(require('./payment').default);

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkLoginStatus = () => {
      const userValue = localStorage.getItem('user');
      if (userValue) {
        setIsLoggedIn(true);
        setUser(JSON.parse(userValue));
      }
    };

    checkLoginStatus();
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        {/* Fixed header */}
        <div className="fixed top-0 left-0 right-0 z-50 bg-white">
          <Header isLoggedIn={isLoggedIn} user={user} />
        </div>

        {/* Main content with padding-top to account for fixed header */}
        <main className="flex-grow mt-16">
          <div>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/payment" element={<ProductDisplay />} />
              <Route path="/about" element={<About />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/forms" element={<Form />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/raiseticket" element={<Raise />} />
              <Route path="/team" element={<Team />} />
              <Route path="/events" element={<Events />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/confirmation" element={<Conform />} />
              <Route path="/privacy&policy" element={<Privacy/>} />
              <Route path="/terms&conditions" element={<Terms/>} />
              <Route path="/tamilschools" element={<Tamil />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/cancel" element={<FailurePage />} />
              <Route path='/reset-password/:token' element={<ResetPassword />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Routes>
          </div>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;